<template>
  <dashboard-section
    v-if="competitions.length"
    class="bg-grey-900 mb-24 pb-px"
  >
    <template #title>
      <h2 class="text-white text-xl">
        Current Competitions
      </h2>
    </template>
    <ul class="list-reset flex flex-wrap -mx-4 -mb-24">
      <li
        v-for="competition in competitions"
        :key="competition.uuid"
        class="w-full lg:w-1/3 lg:flex p-4"
      >
        <admin-competition-card :competition="competition" />
      </li>
      <li
        v-for="filler in [1, 2, 3].slice(competitions.length, 3)"
        :key="filler"
        class="hidden lg:w-1/3 lg:flex p-4"
      >
        <div class="w-full border-dashed border border-grey-100 opacity-25" />
      </li>
    </ul>
  </dashboard-section>
</template>

<script>
export default {
  name: "AdminDashboardCompetitions",
  props: {
    competitions: {
      type: Array,
      default: () => []
    }
  }
};
</script>
